export default __webpack_public_path__ + "static/media/sticker-i.1ab01766.png";